import { RunFlowParams } from '~src/flow/types/FlowParameters';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface RunFlowsParams {
  readonly ids: string[];
  readonly isRunAllIncremental: boolean;
  readonly runFlowParams?: RunFlowParams[];
}

export interface RunFlowsResult extends IResult {
}

export class RunFlowsRequest extends Request<RunFlowsParams, RunFlowsResult> {
  constructor(ids: string[], isRunAllIncremental: boolean, runFlowParams?: RunFlowParams[]) {
    super('runFlows', { ids: ids, isRunAllIncremental, runFlowParams });
  }
}
